<!--
 * @Author: Du Feng
 * @LastEditors: Du Feng
 * @Date: 2022-08-26 11:27:18
 * @LastEditTime: 2022-09-01 09:11:19
 * @Description: Modify here please
-->
<template>
<div>
   <el-cascader
   v-if="type=='seach'"
    v-model="value"
    placeholder="请选择课程类型"
    :options="courseTypeData"
    :props="{ checkStrictly: true }"
    clearable
    @change="handleCourseTypeChange"
  >
  </el-cascader>
      <el-cascader
      v-else
    v-model="value"
    placeholder="请选择课程类型"
    :options="courseTypeData"
    clearable
    @change="handleCourseTypeChange"
  >
  </el-cascader>
</div>
</template>
<script>
import { getCourseTypeData } from "@/utils/courseTypeData.js";
export default {
  components: {},
  props:["type"],
  data() {
    return {
      value: [],
      courseTypeData: getCourseTypeData(),
      courseTypeObj: {
        typeId: "", // 课程类型
        typeName: "", // 课程类型
        subclassId: "", // 小类id
        subclassName: "", // 小类名
      },
    };
  },
  created() {
    console.log('***********',this.type);
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
   setValue(data){
      this.value=data
   },
    handleCourseTypeChange(value) {
      let _this = this.courseTypeObj;
      for (let k in this.courseTypeObj) {
        this.courseTypeObj[k] = "";
      }
      this.courseTypeData.forEach((it) => {
        if (value[0] == it.value) {
          _this.typeId = it.value;
          _this.typeName = it.label;
        }
        it.children.forEach((j) => {
          if (value[1] == j.value) {
            _this.subclassId = j.value;
            _this.subclassName = j.label;
          }
        });
      });
      this.$emit("setCourseType", _this);
    },
  },
};
</script>
<style lang="css" scoped></style>
